import { createContext, useContext, useEffect, useState } from "react";

const ThemeCtx = createContext({ dark: false, toggle: () => {} });

export const ThemeProvider = ({ children }) => {
  const [dark, setDark] = useState(() => document.documentElement.classList.contains("dark"));
  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    document.querySelector('meta[name="theme-color"]')?.setAttribute("content", dark ? "#0a1110" : "#f7f8f6");
  }, [dark]);
  useEffect(() => {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const onChange = (e) => { if (!localStorage.getItem("morpho-theme")) setDark(e.matches); };
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);
  const toggle = () => setDark((d) => { localStorage.setItem("morpho-theme", d ? "light" : "dark"); return !d; });
  return <ThemeCtx.Provider value={{ dark, toggle }}>{children}</ThemeCtx.Provider>;
};

export const useThemeMode = () => useContext(ThemeCtx);

export const shotSrc = (src, dark) => (dark ? src.replace(/\.jpg$/, "-dark.jpg") : src);
